// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AutoCompleteResults-cls1___6ce55f44ce340d8332f{/*!*/}.AutoCompleteResults-cls2___94b1cb5b338cc2d7372{display:flex;flex-direction:column;max-height:200px;overflow:scroll}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AutoCompleteResults-cls1___6ce55f44ce340d8332f",
	"cls2": "AutoCompleteResults-cls2___94b1cb5b338cc2d7372 AutoCompleteResults-cls1___6ce55f44ce340d8332f"
};
export default ___CSS_LOADER_EXPORT___;
